import { render, staticRenderFns } from "./StudentDeraModal.vue?vue&type=template&id=e129373e&"
import script from "./StudentDeraModal.vue?vue&type=script&lang=js&"
export * from "./StudentDeraModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports